import { Button, SparkleIcon } from '@iheartjane/reefer';
import type { ComponentProps } from 'react';

import styles from './wizardFloatingButton.module.css';

interface WizardFloatingButtonProps {
  /**
   * Color for the label + sparkle icon. Should be the store's primary
   * contrast color so the button stays legible on light and dark themes.
   */
  iconColor?: ComponentProps<typeof SparkleIcon>['color'];
  onClickStart: () => void;
}

export const WizardFloatingButton = ({
  iconColor,
  onClickStart,
}: WizardFloatingButtonProps) => {
  return (
    <div className={styles['container']}>
      <Button
        data-testid="wizard-floating-button"
        label="Ask AI Budtender"
        onClick={onClickStart}
        startIcon={<SparkleIcon size="sm" color={iconColor} />}
        variant="primary"
      />
    </div>
  );
};
